import { isOn } from 'util/index';
import { P2P_OFF_ON } from 'consts';
import { useFormikContext } from 'formik';

const useP2PDisabled = () => {
  const { values = [] } = useFormikContext();

  const onOff = values?.[P2P_OFF_ON];
  const enabled = isOn(onOff) || onOff === undefined;

  return !enabled;
};

export default useP2PDisabled;
